<header class="page-header">
    <div>
        <h1 class="page-header__title">{{ 'authentication.newPasswordRequired.title' | translate }}</h1>
        <p class="page-header__description">{{ 'authentication.newPasswordRequired.description' | translate }}</p>
    </div>
</header>
<form class="form-grid" [formGroup]="newPasswordRequiredForm" (ngSubmit)="onSubmit()">
    <div class="form-field">
        <label for="new-password" class="form-field__label form-field__label--required">{{
            'authentication.newPasswordRequired.form.password' | translate
        }}</label>
        <p-iconfield>
            <p-inputicon styleClass="ms ms-key" />
            <input
                id="new-password"
                [placeholder]="'authentication.common.placeholder.newPassword' | translate"
                type="password"
                formControlName="password"
                autocomplete="off"
                pInputText
                [fluid]="true"
                [pTooltip]="'authentication.newPasswordRequired.infotips.newPassword' | translate"
                tooltipPosition="top"
                [positionTop]="-5" />
        </p-iconfield>
        @if (f.password.touched && f.password.errors?.required) {
            <small class="p-error">{{
                'authentication.newPasswordRequired.validation.requiredPassword' | translate
            }}</small>
        }
        @if (f.password.touched && f.password.errors?.invalidPassword) {
            <small
                class="p-error"
                [innerHtml]="'authentication.newPasswordRequired.validation.invalidPassword' | translate"></small>
        }
    </div>
    <div class="form-field">
        <label for="new-password-confirm" class="form-field__label form-field__label--required">{{
            'authentication.newPasswordRequired.form.confirmPassword' | translate
        }}</label>
        <p-iconfield>
            <p-inputicon styleClass="ms ms-key" />
            <input
                id="new-password-confirm"
                [placeholder]="'authentication.common.placeholder.confirmPassword' | translate"
                type="password"
                formControlName="confirmPassword"
                autocomplete="off"
                pInputText
                [fluid]="true" />
        </p-iconfield>
        @if (f.confirmPassword.touched && f.confirmPassword.errors?.required) {
            <small class="p-error">{{
                'authentication.newPasswordRequired.validation.requiredPassword' | translate
            }}</small>
        }
        @if (f.confirmPassword.touched && f.confirmPassword.errors?.mustMatch) {
            <small class="p-error">{{
                'authentication.newPasswordRequired.validation.notMatchingPassword' | translate
            }}</small>
        }
    </div>
    <p-button
        type="submit"
        [loading]="loading"
        [label]="'authentication.newPasswordRequired.button' | translate"
        [fluid]="true" />
</form>
<a routerLink="/auth/login" class="auth-back text-color-secondary text-sm">
    <span class="material-symbols-outlined icon-sm" aria-hidden="true">chevron_left</span>
    {{ 'authentication.common.navigationBack' | translate }}
</a>
